// Everything Material-UI related that we want to override goes here
// https://material-ui.com/customization/components/#global-theme-override
const lightOverrides = {
    // @ts-ignore
    MuiSkeleton: {
        root: {
            borderRadius: 4,
        },
        wave: {
            '&::after': {
                backgroundImage: `linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.04), transparent)`,
            },
        },
    },
};
export default lightOverrides;
